import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M20.25 9.734a.75.75 0 0 0-.75.75v3.766h-3a2.25 2.25 0 0 0-2.25 2.25v3h-7.5a2.25 2.25 0 0 1-2.25-2.25V6.75A2.25 2.25 0 0 1 6.75 4.5h6.781a.75.75 0 1 0 0-1.5H6.75A3.754 3.754 0 0 0 3 6.75v10.5A3.754 3.754 0 0 0 6.75 21h8.507a3.73 3.73 0 0 0 2.652-1.098l1.992-1.994A3.73 3.73 0 0 0 21 15.259v-4.774a.75.75 0 0 0-.75-.75m-3.401 9.108a2.23 2.23 0 0 1-1.099.6V16.5a.75.75 0 0 1 .75-.75h2.944c-.093.415-.301.796-.6 1.098z" }, null, -1),
    _createElementVNode("path", { d: "m17.352 3.607-8.35 8.362A3.4 3.4 0 0 0 8 14.393v.921a.686.686 0 0 0 .685.686h.92a3.4 3.4 0 0 0 2.42-1.004l8.35-8.362a2.145 2.145 0 0 0 0-3.027 2.186 2.186 0 0 0-3.023 0m2.055 2.058-8.35 8.361c-.386.385-.908.6-1.452.602H9.37v-.235a2.07 2.07 0 0 1 .601-1.455l8.35-8.361a.786.786 0 0 1 1.086 0 .77.77 0 0 1 0 1.088" }, null, -1)
  ]))]))
}
export default { render: render }